import firebase from 'firebase'

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyA6YrxTBTsxt2MXx07vSHRvJKlAM-e5xUs",
    authDomain: "plmforum-25dcf.firebaseapp.com",
    projectId: "plmforum-25dcf",
    storageBucket: "plmforum-25dcf.appspot.com",
    messagingSenderId: "926757076254",
    appId: "1:926757076254:web:b78612ad9a821d997fdd0f",
    measurementId: "G-HK6DEPHVSK"
};

const firebase_ = firebase.initializeApp(firebaseConfig)
export default firebase_;
// export const firestore_ = firebase.firestore()
